import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-add-notification-destination-teams',
  templateUrl: './help-add-notification-destination-teams.component.html',
  styleUrls: ['./help-add-notification-destination-teams.component.scss']
})
export class HelpAddNotificationDestinationTeamsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
